import { ConversationMessageMetadata } from "@shaarp/common";
import { UIMessage } from "ai";

/**
 * Whether a thread ends on the user's own question, with no answer after it.
 *
 * A server killed in the middle of a turn (out of memory, a restart) writes
 * nothing: no answer, no marker, no error. Once the reconnections have run
 * out, the reloaded thread is the only trace left, and this shape is the one
 * the reader cannot explain by looking at it.
 */
export const isLastMessageUnanswered = (
  messages: UIMessage<ConversationMessageMetadata>[],
): boolean => messages[messages.length - 1]?.role === "user";
